<kilowant-header title="Common Questions" [showAccountList]="false" [isBuyer]="(user==null)?false:true" [isHome]="(user==null)?true:false" [linkHome]="(user==null)?'/':'/user/home'"></kilowant-header>
<div class="wrapper-main-public-area">
  <div class="form">
      <div class="faq-area">
          <ul>
              @for (f of faq(); track f; let i = $index) {
              <li>
                  <a [class]="(i!=faqOpenQuestion)?'plus-dark-icon':'minus-dark-icon'" style="float: left; margin-left:-25px; width: 20px; height: 20px;" (click)="viewQuestion(i)"></a>
                  <h3 class="link" (click)="viewQuestion(i)">{{f.question}}</h3>
                  @if (i==faqOpenQuestion) {
                  <span>{{f.answer}}</span>
                  }
              </li>
              }
          </ul>
      </div>
  </div>
</div>
<div class="footer-bottom-fixed-full-width">
    <div class="wrapperMain">
        <div class="bottom-selector" [class]="(contactUsOpened)?'extended':''">
            <span class="title" (click)="contactOpen()">Contact Us</span>
            <div class="footer-basement" [style.height]="(!contactUsOpened)?'0':'auto'">
                <div class="grey-text footer-scroll">
                    <ul>
                        <li class="i-mail"><a href="mailto:info@kilowant.com">info&#64;kilowant.com</a></li>
                        <li class="i-phone">401.487.1652</li>
                        <li class="i-address">
                            Kilowant LLC<br />
                            P.O. Box 299<br />
                            Charlestown, RI 02813
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>